<template>
    <component v-bind:is="bracketComponent" v-bind:bracket="bracketData" :id="bracketData.id"></component>
</template>

<script>

    import SingleElimination from "./Brackets/SingleElimination";
    import LowerBracket from "./Brackets/LowerBracket";
    export default {
        name: "Bracket",
        components: {SingleElimination, LowerBracket},
        props:{
            id: Number,
            bracket: Object
        },
        data: function(){
            return {
                isLoading: true,
                bracketData:null,
                bracketType:{'single_elimination':'SingleElimination', 'lower_bracket':'LowerBracket'},
                bracketComponent:null,
            }
        },
        created: function(){
            this.getData();
        },
        methods: {
            getData(){
                this.bracketData=this.$props.bracket;
                this.isLoading=false;
                console.log(this.bracketData);
                console.log(this.bracketType[this.bracketData.bracket_type]);
                this.bracketComponent=this.bracketType[this.bracketData.bracket_type];
            }
        },
        watch: {
            id: function(newVal, oldVal) { // watch it

                if(newVal !== oldVal){
                    this.isLoading=true;
                    this.getData();
                }

            }
        }
    }
</script>

<style scoped>

</style>